import Content from './content.js';
import DataTables from './components/dataTables';

export default class Table extends Content {
  onDestroy() {
    this.dataTable.remove();
  }

  render() {
    var opts = this._parseOpts(this.opts);

    this.dataTable = new DataTables(opts);
    this.dataTable.start();
  }

  _parseOpts(opts) {
    opts.el = this.$(this.dom.DATATABLES);
    opts.columns = window.da_grid_columns;
    return opts;
  }

  hideMultipleValuesOptionToBooleanProperties(selector) {
    $(selector).on('change', function () {
      if ($(this).val() === 'boolean') {
        $('tr:has(label:contains("Multiple Values"))').addClass('hidden');
      } else {
        $('tr:has(label:contains("Multiple Values"))').removeClass('hidden');
      }
    });
  }
}
